import { BaseOptionType } from 'antd/es/select'

const getOptionsWithOneMoreValue = (
  options: BaseOptionType[],
  currentRole: string | undefined
) => {
  if (!currentRole) {
    return options
  }

  const valuesOnly = options.map((role) => role.value)
  if (valuesOnly.includes(currentRole)) {
    return options
  }

  const newRoles = options.concat({
    value: currentRole,
    label: currentRole,
    disabled: true,
  })

  return newRoles
}

export default getOptionsWithOneMoreValue